// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GWzK","right":"styles_right__1j2Y9"};